import type { ReactNode } from 'react';
import { Warning } from '@react-apps/design-system';

/**
 * Aviso fixo do content: fica enquanto o conteúdo está na tela, ao contrário
 * do toast, que some. Nasceu no aviso de questão anulada e hoje serve também
 * ao lock de edição.
 *
 * O DS não tem Alert: é Tailwind inline, como o aviso da TOTVS, com os pares
 * `warning` de `styles/tokens.ts` (são os valores do `amber`). O ícone é
 * decorativo (o `Icon` do DS já sai com `aria-hidden`), e o texto carrega o
 * significado.
 *
 * `role` é de quem chama: sem ele para o que existe ao montar (`status` só
 * anuncia mudança), `status` para o que aparece depois de uma ação, `alert`
 * para o que pede ação agora.
 */
export function ContentNotice({
  id,
  role,
  action,
  children,
}: {
  id?: string;
  role?: 'status' | 'alert';
  /** Botão abaixo do texto, quando o aviso tem uma saída. */
  action?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div
      id={id}
      role={role}
      className="flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm font-medium text-amber-800 dark:border-amber-900 dark:bg-amber-950/40 dark:text-amber-300"
    >
      <Warning size="sm" className="mt-0.5 shrink-0" />
      <div className="space-y-2">
        <p>{children}</p>
        {action}
      </div>
    </div>
  );
}
